// Base configuration for all environments
const API_PORT = process.env.API_PORT || 8000;
const config = {
  development: {
    API_BASE_URL: `http://localhost:${API_PORT}`
  },
  production: {
    API_BASE_URL: 'https://processor.globe-data.tech' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: `http://localhost:${API_PORT}`
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = config[env].API_BASE_URL;

export const COOKIE_DOMAIN = process.env.COOKIE_DOMAIN || '.globe-data.tech';
export const COOKIE_SECURE = process.env.NODE_ENV === 'production'; // true en production, false en développement
export const COOKIE_MAX_AGE = 7 * 24 * 60 * 60; // 7 jours en secondes

// You can add more configuration exports here if needed
export default {
  API_BASE_URL
};
